module.exports = __webpack_public_path__ + "static/media/BINANCE.aac25fbf.png";